import React, { CSSProperties, ReactNode } from "react";
import "./style.scss";

interface NavigationDrawerProps {
  modelValue?: boolean;
  width?: number | string;
  hideOverlay?: boolean;
  children: ReactNode;
  onUpdateModelValue: (value: boolean) => void;
  zIndex?: string;
  zIndexOverlay?: string;
}

const NavigationDrawer: React.FC<NavigationDrawerProps> = ({
  modelValue = false,
  width = "300px",
  hideOverlay = false,
  children,
  onUpdateModelValue,
  zIndex,
  zIndexOverlay,
}) => {
  const isMobile = window.innerWidth <= 1280;

  const drawerStyle: CSSProperties = {
    width: isMobile ? "100%" : width,
    zIndex: zIndex || 2200,
    position: "fixed",
    right: isMobile ? "auto" : 0,
    left: isMobile ? 0 : "auto",
    top: isMobile ? "auto" : 0,
    bottom: isMobile ? 0 : 0,
    backgroundColor: "#fff",
    transition: "transform 0.3s ease-in-out",
    transform: modelValue
      ? isMobile
        ? "translateY(0)"
        : "translateX(0)"
      : isMobile
        ? "translateY(100%)"
        : "translateX(200%)",
    maxWidth: "100%",
    overflowY: isMobile ? "auto" : "initial",
    height: isMobile ? "100vh" : "auto",
  };

  const overlayStyle: CSSProperties = {
    zIndex: zIndexOverlay || 2100,
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    transition: "opacity 0.3s ease-in-out",
    opacity: modelValue ? 1 : 0,
    visibility: modelValue ? "visible" : "hidden",
  };

  return (
    <>
      <div style={drawerStyle} className='navigation-drawer'>
        {children}
      </div>
      {!hideOverlay && (
        <div
          style={overlayStyle}
          className='navigation-drawer__overlay'
          onClick={() => onUpdateModelValue(false)}
        />
      )}
    </>
  );
};

export default NavigationDrawer;
